<template>
  <b-modal
      v-model="visible"
      centered
      hide-header
      hide-footer
      size="md"
      no-close-on-backdrop
      content-class="border-0 shadow"
  >
    <div class="p-3 text-center">
      <div class="d-flex justify-content-center mb-3">
        <img :src="WarningIcon" alt="Warning Icon" style="width: 48px; height: 48px;" />
      </div>
      <h3 class="modal-title-text mb-2">{{ $t('users.update_blocked_title') }}</h3>
      <p class="modal-description-text text-muted mb-4" v-html="descriptionHTML"></p>
      <div class="d-grid gap-2">
        <b-button variant="primary" block class="w-100 py-2 btn-dismiss" @click="hide">
          {{ $t('Close') }}
        </b-button>
      </div>
    </div>
  </b-modal>
</template>

<script>
import WarningIcon from "@/assets/icons/WarningIcon.svg"

export default {
  name: "UserApproverBlockedModal",
  data() {
    return {
      WarningIcon,
      visible: false,
      name: "",
    }
  },
  computed: {
    descriptionHTML() {
      return this.$t('users.update_blocked_description', {
        name: `<strong class="text-dark">${this.lodash.escape(this.name)}</strong>`
      });
    }
  },
  methods: {
    show({ name }) {
      this.name = name;
      this.visible = true;
    },
    hide() {
      this.visible = false;
      this.$emit('close');
    }
  }
}
</script>

<style scoped lang="scss">
.modal-title-text {
  font-family: 'Lato', 'Inter', sans-serif;
  font-weight: 700;
  font-size: 18px;
  line-height: 28px;
  color: #1F2A37;
}

.modal-description-text {
  font-family: 'Lato', 'Inter', sans-serif;
  font-size: 14px;
  line-height: 20px;
  color: #4B5563;
}

.btn-dismiss {
  color: #182230;
  background-color: #F2F4F7;
  border: none;
  font-weight: 600;
  &:hover {
    background-color: #E8EBEE;
  }
}
</style>
